import SectionHeading from "./SectionHeading";

const timeline = [
  {
    date: "2026-09-04",
    week: "第 36 周",
    tone: "bg-primary-500",
    tag: "处罚",
    title: "直播专项治理通报首批处置名单",
    text: "平台公告对涉违规直播账号进行限流与功能冻结，处置口径同步公开，成为本周讨论最高议题。",
  },
  {
    date: "2026-08-28",
    week: "第 35 周",
    tone: "bg-accent-600",
    tag: "监管",
    title: "属地监管部门就内容审核开展约谈",
    text: "约谈聚焦未成年人保护与低质内容治理，要求平台压实责任并定期报送整改进展。",
  },
  {
    date: "2026-08-19",
    week: "第 34 周",
    tone: "bg-foreground-800",
    tag: "下架",
    title: "涉「诱导充值」短剧开启集中下架",
    text: "多部付费短剧被移出平台，下架范围随时间扩大，引发对是否误伤普通剧集的讨论。",
  },
  {
    date: "2026-08-11",
    week: "第 33 周",
    tone: "bg-secondary-700",
    tag: "审核",
    title: "推荐算法说明文档更新上线",
    text: "平台公开新版算法与内容质量说明，但创作者普遍反馈仍缺乏可量化的判定依据。",
  },
  {
    date: "2026-07-29",
    week: "第 31 周",
    tone: "bg-primary-500",
    tag: "处罚",
    title: "一批「流量异常」账号被批量限流",
    text: "数据异常的认定标准未完全公开，申诉通道与响应效率成为评论区集中追问点。",
  },
];

export default function Timeline() {
  return (
    <section id="timeline" className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid w-full grid-cols-1 gap-8 lg:grid-cols-[340px_1fr] lg:gap-12">
          <div className="flex flex-col">
            <SectionHeading
              kicker="监管 · 处罚 · 下架 时间轴"
              title="风波时间线"
              desc="把官方处罚、内容下架与监管动作按时间排列。别被单条消息带节奏——看完整条线，才知道风波的来龙去脉。"
              accent
            />
            <div className="mt-6 hidden rounded-xl border border-background-200 bg-background-100 p-4 lg:block">
              <div className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
                <i className="ri-calendar-check-line text-primary-600" />
                更新频率
              </div>
              <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">
                每周一汇总上一周期新增的处罚、下架与监管公告，同时回访旧议题是否有新进展或反转。
              </p>
            </div>
          </div>

          <ol className="relative ml-3 flex flex-col gap-0 border-l border-background-200 md:ml-0">
            {timeline.map((t) => (
              <li key={t.date} className="relative pb-6 pl-7 last:pb-0">
                <span
                  className={`absolute -left-[7px] top-1 flex h-[13px] w-[13px] items-center justify-center rounded-full ring-4 ring-background-50 ${t.tone}`}
                />
                <div className="flex flex-col gap-1 rounded-xl border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="whitespace-nowrap font-label text-xs font-bold text-foreground-950">{t.date}</span>
                    <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                      {t.week}
                    </span>
                    <span
                      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold text-background-50 ${t.tone}`}
                    >
                      {t.tag}
                    </span>
                  </div>
                  <h3 className="font-label text-[15px] font-semibold text-foreground-950">{t.title}</h3>
                  <p className="text-[13px] leading-relaxed text-foreground-600">{t.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}